export default class vImage {
  constructor() {
    this.images = {};
    this.response = {};
  }

  add(event) {
    this.images[event.name] = event.file;
    this.images[`${event.name}Crop`] = JSON.stringify(event.crop);
  }

  send(path, callback) {
    const formData = new FormData();

    Object.keys(this.images).map((objectKey) => {
      formData.append(objectKey, this.images[objectKey]);
    });

    if (Object.keys(this.images).length != 0) {
      globalEventBus.$snotify.async(
        'On enregistre vos images...',
        'Patience',
        () =>
          new Promise((resolve, reject) => {
            axios
              .post(path, formData, {
                headers: {
                  'content-type': 'application/x-www-form-urlencoded',
                },
              })
              .then((res) => {
                this.response = res.data;
                if (res.data.updated === true || res.data.created === true) {
                  globalEventBus.$emit('uploaded', res.data);
                  resolve({
                    title: "C'est bon !",
                    body: this.imageSendComplete(),
                    config: {
                      timeout: 1500,
                    },
                  });
                  // If the post succeed, the callback function is called
                  typeof callback === 'function' && callback();
                } else {
                  globalEventBus.$emit('upload-failed', res.data);
                  reject({
                    body: "Une erreur est survenue lors de l'enregistrement des images, \n Veuilliez réessayer ultérieurement et nous recontacter si le problème persiste.",
                    config: {
                      timeout: 5000,
                    },
                  });
                }
              })
              .catch(function (error) {
                globalEventBus.$emit('upload-failed', error);
                reject({
                  body: "Une erreur est survenue lors de l'enregistrement des images, \n Veuilliez réessayer ultérieurement et nous recontacter si le problème persiste",
                  config: {
                    timeout: 5000,
                  },
                });
              });
          }),
      );
    }
  }

  imageSendComplete() {
    return Object.keys(this.images).length >= 1
      ? 'On a bien enregistré vos images !'
      : 'On a bien enregistré vôtre image';
  }
}
